import React, { useEffect, useState } from "react";
import HomePageNavbar from "../Components/HomePageNavbar";
import HomePageNavbarFinancials from "../Components/HomePageNavbarFinancials";
import HomePageNavbarInventory from "../Components/HomePageNavbarInventory";
import axios from "axios";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../Components/Loading";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import { setDivision } from "../Redux/Action/division";
import Navbar from "../Components/AllPageNavbar";
import DashBoardNavbar from "../Components/DashBoardNavbar";
import ListOfOrders from "./ListOfOrders";
import CashPOSPopUp from "../Pages/ORDERTAKER/CashPOS";
import { setActiveTab } from "../Redux/Action/activeTab"

const HomePage = ({ hideNavBar }) => {
  const BASEURL = process.env.REACT_APP_BASEURL;
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const userState = useSelector((state) => state.changeTheState.user);
  const email = userState?.emailId;
  console.log("Email:",email)
  const divisionState = useSelector((state) => state.changeDivision);
  console.log(hideNavBar)
  const currentDate = new Date();
  const startOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1,
  );
  const localStartOfMonth = new Date(
    startOfMonth.getTime() - startOfMonth.getTimezoneOffset() * 60000,
  );
  const navigate = useNavigate();
  const [startdate, setstartdate] = useState(localStartOfMonth.toISOString());
  const [enddate, setEnddate] = useState(currentDate.toISOString());
  const [isloading, setisloading] = useState(true);
  const [cashdata, setcashdata] = useState([]);
  const [creditdata, setcreditdata] = useState([]);
  const [creditflag, setcreditflag] = useState(false);
  const [userdivisionRights, setuserDivisionList] = useState([]);
  const [totalVat, settotalVat] = useState(0);
  const [totalLevy, settotalLevy] = useState(0);
  const [totalExcl, settotalExcl] = useState(0);
  const [totalIncl, settotalIncl] = useState(0);
  const [poHeaders, setPoHeaders] = useState([]);

  // ************** List Of Orders ***********************

  const [listOfOrders, setlistOfOrders] = useState([]);
  const loggedInUser = userState?.emailId?.split("@")[0].toUpperCase();
  const [clientList, setClientlist] = useState([]);
  const [unpaidBills, setUnpaidBills] = useState([]);
  const [searchUnpaid, setSearchUnpaid] = useState("");
  const [uBStartdate, setUbStartDate] = useState(
    localStartOfMonth.toISOString(),
  );
  const [ubEndDate, setUbEndDate] = useState(currentDate.toISOString());
  const [ubtotal, setUbTotal] = useState(0);
  const [ubTotalAmount, setUbTotalAmount] = useState(0);

  const [salesBills, setSalesBills] = useState([]);
  const [searchSales, setSearchSales] = useState("");
  const [salStartdate, setSalStartDate] = useState(
    currentDate.toISOString(),
  );
  const [salEndDate, setSalEndDate] = useState(currentDate.toISOString());
  const [salTotal, setSalTotal] = useState(0);
  const [salTotalAmount, setSalTotalAmount] = useState(0);

  const [showCashPos, setShowCashPos] = useState(false);
  const [orderNo, setOrderNo] = useState("");

    const activeTab = useSelector((state) => state.changeActiveTab);

  useEffect(() => {
    getListOfClients();
  }, []);

  useEffect(() => {
    axios
      .get(`${BASEURL}/getdivisionRights?OM_USER_ACCOUNT=${email}`)
      // .get(
      //   `${BASEURL_GLOBAL}/globalViewHandler?viewname=568&OM_USER_ACCOUNT=${email}`,
      //   {
      //     headers: {
      //       "auth-token": authToken,
      //       "session-token": sessiontoken,
      //     },
      //   }
      // )
      .then((response) => {
        console.log(response?.data[0]);
        dispatch(setDivision(response?.data[0]?.OM_USER_DIVISION));
        setuserDivisionList(response.data);
        axios
          // .get(`${BASEURL}/getOrderStatus?DIVISION=${divisionState}`, {
          .get(
            `${BASEURL_GLOBAL}/globalViewHandler?viewname=588&DIVISION=${response?.data[0]?.OM_USER_DIVISION}`,
            {
              headers: {
                "auth-token": authToken,
                "session-token": sessiontoken,
              },
            },
          )
          .then((response) => {
            console.log(response.data);
            const filteredOrders = response.data.filter(
              (order) => order.PICKEDUP !== true,
            );
            setlistOfOrders(filteredOrders);
            console.log(filteredOrders);
            setisloading(false);
          })

          .catch((error) => {
            console.error(
              "Error fetching List Of Orders /getOrderStatus:",
              error,
            );
          });
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const getListOfClients = () => {
    setisloading(true);
    axios
      // .get(`${BASEURL}/getListOfClients`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=685`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        console.log(response.data);
        setClientlist(response.data);
        setisloading(false);
      })
      .catch((error) => {
        console.error("Error fetching List Of /getListOfClients:", error);
        setisloading(false);
      });
  };

  const getOrderItems = (value, table, vat, client, clientCode) => {
    axios
      .get(
        // `${BASEURL}/getOrderItems?ENQUIRYNO=${value}`,
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=587&ENQUIRYNO=${value}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((response) => {
        console.log(response?.data);
        const selectedOption = clientList?.find(
          (obj) => obj["CLIENT NAME"] === client,
        );
        console.log(selectedOption["CASH/CREDIT CUSTOMER"]);
        if (selectedOption["CASH/CREDIT CUSTOMER"] === "CASH") {
          navigate("/CashPOS", {
            state: {
              tableData: response?.data,
              table: table,
              totalVat: vat,
            },
          });
        } else if (selectedOption["CASH/CREDIT CUSTOMER"] === "CREDIT") {
          navigate("/CreditPOS", {
            state: {
              tableData: response?.data,
              table: table,
              totalVat: vat,
              client: client,
              clientCode: clientCode,
            },
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching List Of Items:", error);
      });
  };

  async function PickUp(orderNo) {
    setisloading(true);
    try {
      const response = await axios.post(
        // `${BASEURL}/orderStatusUpdate`,
        `${BASEURL_GLOBAL}/globalSpHandler?spname=692`,
        {
          ORDERNO: Number(orderNo),
          STATUSTYPE: "PICKUP",
          STATUSUPDATEDBY: loggedInUser,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      );

      if (response.status === 201) {
        alert("Picked Up Successfully");
        setisloading(false);
      } else {
        alert(response.data.message);
        setisloading(false);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Status /orderStatusUpdate`, error);
      alert(error.response.data.message);
    }
  }
  // *************** End Of List **********************************
  const dispatch = useDispatch();
  const filtCash = cashdata.filter((item) => {
    const sDate = item.INVDATE;
    const eDate = item.INVDATE;

    if (!startdate && !enddate) {
      return true;
    }

    const dateMatch =
      (!startdate || sDate >= startdate) && (!enddate || eDate <= enddate);

    return dateMatch;
  });

  const filtCredit = creditdata.filter((item) => {
    const sDate = item.INVDATE;
    const eDate = item.INVDATE;

    if (!startdate && !enddate) {
      return true;
    }

    const dateMatch =
      (!startdate || sDate >= startdate) && (!enddate || eDate <= enddate);

    return dateMatch;
  });

  useEffect(() => {
    let totalvat = 0;
    let totallevy = 0;
    let totalexcl = 0;
    let totalincl = 0;

    if (creditflag === false) {
      filtCash.forEach((item) => {
        totalvat += parseFloat(item["VAT AMT"]) || 0;
        totallevy += parseFloat(item["LEVY AMT"]) || 0;
        totalexcl += parseFloat(item["AMOUNT EXCLUSIVE VAT"]) || 0;
        totalincl += parseFloat(item["AMOUNT INCLUSIVE VAT"]) || 0;
      });

      settotalVat(totalvat);
      settotalLevy(totallevy);
      settotalExcl(totalexcl);
      settotalIncl(totalincl);
    }
  }, [filtCash, creditflag]);

  useEffect(() => {
    let totalvat = 0;
    let totallevy = 0;
    let totalexcl = 0;
    let totalincl = 0;

    if (creditflag === true) {
      filtCredit.forEach((item) => {
        totalvat += parseFloat(item["VAT AMT"]) || 0;
        totallevy += parseFloat(item["LEVY AMT"]) || 0;
        totalexcl += parseFloat(item["AMOUNT EXCLUSIVE VAT"]) || 0;
        totalincl += parseFloat(item["AMOUNT INCLUSIVE VAT"]) || 0;
      });

      settotalVat(totalvat);
      settotalLevy(totallevy);
      settotalExcl(totalexcl);
      settotalIncl(totalincl);
    }
  }, [filtCredit, creditflag]);


  const getSalesBreakdown = () => {
    axios
      // .get(`${BASEURL}/SalesBreakdownCash`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=624`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setcashdata(response.data);
      })
      .catch((error) => {
        console.error("Error fetching Sales Breakdown Cash Sales:", error);
      });

    axios
      // .get(`${BASEURL}/SalesBreakdownCredit`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=623`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setcreditdata(response.data);
        // setisloading(false);
      })
      .catch((error) => {
        console.error("Error fetching Sales Breakdown Credit Sales:", error);
        // setisloading(false);
      });
  };

  // useEffect(getSalesBreakdown, []);
  useEffect(() => {
    getSalesBreakdown();
    getPurchaseOrderDetails();
    getSalesTabData();
  }, []);

  function getPurchaseOrderDetails() {
    // setisloading(true);
    axios
      // .get(`${BASEURL}/getPoHeaders`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=645`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setPoHeaders(response?.data);
        setisloading(false);
      })
      .catch((err) => {
        setisloading(false);
        console.log("Error while fetching Purchase Order Details", err);
      });
  }

  // SALES TAB DATA

  const getSalesTabData = () => {
    axios
      // .get(`${BASEURL}/SalesBreakdownCash`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1680`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        const sortedData = response?.data?.sort(
          (a, b) => new Date(b.DATETIME) - new Date(a.DATETIME),
        );
        setUnpaidBills(sortedData);
      })
      .catch((error) => {
        console.error("Error fetching 1680", error);
      });

    if (email == "nelcashier@gbsafrica.net" || email == "nelpos@gbsafrica.net") {
   axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1706`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        const sortedData = response?.data?.sort(
          (a, b) => new Date(b.DATETIME) - new Date(a.DATETIME),
        );
        setSalesBills(sortedData);
        setisloading(false);
      })
      .catch((error) => {
        console.error("Error fetching 1706:", error);
        // setisloading(false);
      });
    } else {
    axios
      // .get(`${BASEURL}/SalesBreakdownCredit`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1706&WAITER=${loggedInUser}`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        const sortedData = response?.data?.sort(
          (a, b) => new Date(b.DATETIME) - new Date(a.DATETIME),
        );
        setSalesBills(sortedData);
        setisloading(false);
      })
      .catch((error) => {
        console.error("Error fetching 1706:", error);
        // setisloading(false);
      });
    }
  };

  // Filters
  const filtOrders = unpaidBills.filter((item) => {
    const searchData = searchUnpaid.toLowerCase().split(" ").filter(Boolean);
    // const itemDate = new Date(item.DATETIME);
    const itemDate = item.DATETIME
      ? new Date(item.DATETIME.replace("Z", ""))
      : null;
    const start = uBStartdate ? new Date(uBStartdate) : null;
    const end = ubEndDate ? new Date(ubEndDate) : null;

    if (start) start.setHours(0, 0, 0, 0);
    if (end) end.setHours(23, 59, 59, 999);

    // if (searchData.length === 0 && !uBStartdate && !ubEndDate && !status) {
    if (searchData.length === 0 && !uBStartdate && !ubEndDate) {
      // if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      // return ["CLIENT NAME", "BILLNO", "MODEOFPAY", "PONOTES"].some(
      return ["BILLNO", "TABLENO", "DIVISION", "CURRENCY", "WAITER"].some(
        (key) => {
          const columnValue = String(item[key]).toLowerCase();
          return columnValue.includes(term);
        },
      );
    });

    const dateMatch =
      (!start || itemDate >= start) && (!end || itemDate <= end);

    return textMatch && dateMatch;
  });

  const filtSales = salesBills.filter((item) => {
    const searchData = searchSales.toLowerCase().split(" ").filter(Boolean);
  const itemDate = item?.CREATEDDATE
    ? new Date(item.CREATEDDATE).toISOString().split("T")[0]
    : null;

  const startDate = salStartdate
    ? new Date(salStartdate).toISOString().split("T")[0]
    : null;

  const endDate = salEndDate
    ? new Date(salEndDate).toISOString().split("T")[0]
    : null;



    if (searchData.length === 0 && !startDate && !endDate) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return ["BILLNO", "TABLENO", "DIVISION", "CURRENCY", "WAITER"].some(
        (key) => {
          const columnValue = String(item[key]).toLowerCase();
          return columnValue.includes(term);
        },
      );
    });

    const dateMatch =
      (!startDate || itemDate >= startDate) && (!endDate || itemDate <= endDate);

    return textMatch && dateMatch;
  });

  useEffect(() => {
    let total = 0;

    if (creditflag === false) {
      filtOrders.forEach((item) => {
        total += parseFloat(item.AMOUNT) || 0;
      });
      setUbTotal(total);
    }
  }, [filtOrders]);

  useEffect(() => {
    let total = 0;

    if (creditflag === false) {
      filtSales.forEach((item) => {
        total += parseFloat(item.AMOUNT) || 0;
      });
      setSalTotal(total);
    }
  }, [filtSales]);

  if (isloading) {
    return <Loading />;
  }

  return (
    <div>
      <div className=" items-center justify-center">
        <p>
          {!hideNavBar && <DashBoardNavbar />}
        </p>
        {/* <p className="text-2xl italic font-bold mb-1">Mars Track POS</p> */}
      </div>

      {/* <HomePageNavbar /> */}

      {!hideNavBar && <HomePageNavbarFinancials />}      


      {hideNavBar && (
          <>
          {/* Table */}
          <div className="h-[47vh] w-full flex overflow-auto">
            {/* Completely Paid */}
            <aside className="w-[700px]  table__pos__app text-sm overflow-auto">
              <p className="font-bold underline">Sales Dashboard</p>
              <div className="lg:flex items-center gap-1 text-[10px]">
                <p>Search:</p>
                <input
                  className="w-64 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                  type="text"
                  value={searchSales}
                  onChange={(e) => {
                    setSearchSales(e.target.value);
                  }}
                />

                <p className="text-red-600">Start Date:</p>
                <input
                  type="date"
                  className="w-24 h-7 border border-black  p-2 rounded-md focus:outline-none focus:border-blue-500"
                  onChange={(e) => {
                    setSalStartDate(e.target.value);
                  }}
                  value={salStartdate.split("T")[0]}
                ></input>
                <p className="text-red-600 ">End Date:</p>
                <input
                  type="date"
                  className="w-24 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                  onChange={(e) => {
                    setSalEndDate(e.target.value);
                  }}
                  value={salEndDate.split("T")[0]}
                ></input>
              </div>

              <table class="custom-table">
                <thead class="header-cell">
                  <tr className="text-[10px]">
                    <td className="text-left">S no</td>
                    <td className="text-left">DIVISION</td>
                    <td className="pl-2">ORDER NO</td>
                    <td className="text-left">TABLE NO</td>
                    <td className="text-left">WAITER</td>
                    <td className="text-left">ORDER TIME</td>
                    {/* <td className="text-left">CUSTOMER NAME</td> */}
                    <td className="text-right">AMOUNT</td>
                    <td className="text-right">RECEIPT AMOUNT</td>
   <td className="text-left">PENDING</td>
                    <td className="text-right">CURRENCY</td>
                    <td className="text-left">CREATED DATE</td>
                  </tr>
                </thead>
                <tbody>
                  {filtSales.map((row, index) => (
                    <tr
                      key={row?.BILLNO}
                      className={
                        index < salesBills.length
                          ? "border-b cursor-pointer text-[10px] table-row"
                          : ""
                      }
                      onClick={() => {
                        setOrderNo(row.BILLNO);
                        setShowCashPos(true);
                      }}
                    >
                      <td className="text-right">{index + 1}</td>
                      <td className="text-left">{row.DIVISION || ""}</td>
                      <td className="text-right pr-12">
                        {row.BILLNO ? row.BILLNO : ""}
                      </td>
                      <td className="text-left">
                        {row?.TABLENO ? row?.TABLENO : ""}
                      </td>
                      <td className="text-left">
                        {row?.WAITER ? row?.WAITER : ""}
                      </td>
                      <td className="text-left">
                        {row.DATETIME
                          ? moment
                              .utc(row.DATETIME)
                              ?.format("DD-MM-YYYY HH:mm:ss")
                          : ""}
                      </td>
                      {/* <td className="text-left">
                                  {row["CLIENT NAME"] ? row["CLIENT NAME"] : ""}
                                </td> */}
                      <td className="text-right pr-12">
                        {row.AMOUNT
                          ? row.AMOUNT.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "0.0"}
                      </td>
                      <td className="text-right pr-12">
                        {row.RECEIPTAMOUNT
                          ? row.RECEIPTAMOUNT.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "0.0"}
                      </td>
                      <td className="text-right">{row.PENDING || "0"}</td>
                      <td className="text-left">{row.CURRENCY || ""}</td>
                                          <td className="text-left">
                        {row.CREATEDDATE
                          ? moment
                              .utc(row.CREATEDDATE)
                              ?.format("DD-MM-YYYY")
                          : ""}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="w-[625px] sticky bottom-0 z-30 bg-white border-t border-gray-300 flex flex-row items-center gap-2  py-1 shadow-md">
                <p className="mx-2">Total Orders :</p>
                <input
                  className="w-48 h-6 border-black border rounded text-right"
                  value={filtSales.length > 0 ? filtSales.length : "0"}
                  readOnly
                ></input>
                <p className="mx-2">Total Amount :</p>
                <input
                  className="w-48 h-6 border-black border rounded text-right"
                  value={
                    salTotal
                      ? salTotal.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : "0"
                  }
                ></input>
              </div>
            </aside>
          </div>
        </>
      )}
      

       {!hideNavBar && (
      <>  
      
      {(!activeTab || activeTab === "sales") && (
        <>
          {/* Table */}
          <div className="h-[47vh] w-full flex overflow-auto">
            {/* Unpaid */}
            {!hideNavBar && (
              <aside className="w-[700px] table__pos__app text-sm overflow-auto">
                <p className="font-bold underline">
                  Unpaid/Partially Paid Invoices
                </p>
                <div className="lg:flex items-center gap-1 text-[10px]">
                  <p>Search:</p>
                  <input
                    className="w-64 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="text"
                    value={searchUnpaid}
                    onChange={(e) => {
                      setSearchUnpaid(e.target.value);
                    }}
                  />

                  <p className="text-red-600">Start Date:</p>
                  <input
                    type="date"
                    className="w-24 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                    onChange={(e) => {
                      setUbStartDate(e.target.value);
                    }}
                    value={uBStartdate.split("T")[0]}
                  ></input>
                  <p className="text-red-600">End Date:</p>
                  <input
                    type="date"
                    className="w-24 h-7 border border-black  p-2 rounded-md focus:outline-none focus:border-blue-500"
                    onChange={(e) => {
                      setUbEndDate(e.target.value);
                    }}
                    value={ubEndDate.split("T")[0]}
                  ></input>
                </div>
                <table class="custom-table">
                  <thead class="header-cell">
                    <tr className="text-[10px]">
                      <td className="text-left">S no</td>
                      <td className="text-left">DIVISION</td>
                      <td className="pl-2">ORDER NO</td>
                      <td className="text-left">TABLE NO</td>
                      <td className="text-left">WAITER</td>
                      <td className="text-left">ORDER TIME</td>
                      <td className="text-right">AMOUNT</td>
                      <td className="text-right">RECEIPT AMOUNT</td>
                      <td className="text-right">CURRENCY</td>
                    </tr>
                  </thead>
                  <tbody>
                    {filtOrders.map((row, index) => (
                      <tr
                        key={row?.BILLNO}
                        className={
                          index < unpaidBills.length
                            ? "border-b cursor-pointer text-[10px] table-row"
                            : ""
                        }
                        onClick={() => {
                          setOrderNo(row.BILLNO);
                          setShowCashPos(true);
                        }}
                      >
                        <td className="text-right">{index + 1}</td>
                        <td className="text-left">{row.DIVISION || ""}</td>
                        <td className="text-right pr-12">
                          {row.BILLNO ? row.BILLNO : ""}
                        </td>
                        <td className="text-left">
                          {row?.TABLENO ? row?.TABLENO : ""}
                        </td>
                        <td className="text-left">
                          {row?.WAITER ? row?.WAITER : ""}
                        </td>
                        <td className="text-left">
                          {row.DATETIME
                            ? moment
                              .utc(row.DATETIME)
                              ?.format("DD-MM-YYYY HH:mm:ss")
                            : ""}
                        </td>
                        <td className="text-right pr-12">
                          {row.AMOUNT
                            ? row.AMOUNT.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                            : "0.0"}
                        </td>
                        <td className="text-right pr-12">
                          {row.RECEIPTAMOUNT
                            ? row.RECEIPTAMOUNT.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                            : "0.0"}
                        </td>
                        <td className="text-left">{row.CURRENCY || ""}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="sticky bottom-0 z-30 bg-white border-t border-gray-300 flex flex-row items-center gap-2  py-1 shadow-md">
                  <p className="mx-2">Total Orders :</p>
                  <input
                    className="w-48 h-6 border-black border rounded text-right"
                    value={filtOrders.length > 0 ? filtOrders.length : "0"}
                    readOnly
                  ></input>
                  <p className="mx-2">Total Amount :</p>
                  <input
                    className="w-48 h-6 border-black border rounded text-right"
                    value={
                      ubtotal
                        ? ubtotal.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                        : "0"
                    }
                    readOnly
                  ></input>
                </div>
              </aside>
            )}
            {/* Completely Paid */}
            <aside className="w-[700px]  table__pos__app text-sm overflow-auto">
              <p className="font-bold underline">Sales Dashboard</p>
              <div className="lg:flex items-center gap-1 text-[10px]">
                <p>Search:</p>
                <input
                  className="w-64 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                  type="text"
                  value={searchSales}
                  onChange={(e) => {
                    setSearchSales(e.target.value);
                  }}
                />

                <p className="text-red-600">Start Date:</p>
                <input
                  type="date"
                  className="w-24 h-7 border border-black  p-2 rounded-md focus:outline-none focus:border-blue-500"
                  onChange={(e) => {
                    setSalStartDate(e.target.value);
                  }}
                  value={salStartdate.split("T")[0]}
                ></input>
                <p className="text-red-600 ">End Date:</p>
                <input
                  type="date"
                  className="w-24 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                  onChange={(e) => {
                    setSalEndDate(e.target.value);
                  }}
                  value={salEndDate.split("T")[0]}
                ></input>
              </div>

              <table class="custom-table">
                <thead class="header-cell">
                  <tr className="text-[10px]">
                    <td className="text-left">S no</td>
                    <td className="text-left">DIVISION</td>
                    <td className="pl-2">ORDER NO</td>
                    <td className="text-left">TABLE NO</td>
                    <td className="text-left">WAITER</td>
                    <td className="text-left">ORDER TIME</td>
                    <td className="text-right">AMOUNT</td>
                    <td className="text-right">RECEIPT AMOUNT</td>
                    <td className="text-left">PENDING</td>
                    <td className="text-right">CURRENCY</td>
                    <td className="text-left">CREATED DATE</td>
                  </tr>
                </thead>
                <tbody>
                  {filtSales.map((row, index) => (
                    <tr
                      key={row?.BILLNO}
                      className={
                        index < salesBills.length
                          ? "border-b cursor-pointer text-[10px] table-row"
                          : ""
                      }
                      onClick={() => {
                        setOrderNo(row.BILLNO);
                        setShowCashPos(true);
                      }}
                    >
                      <td className="text-right">{index + 1}</td>
                      <td className="text-left">{row.DIVISION || ""}</td>
                      <td className="text-right pr-12">
                        {row.BILLNO ? row.BILLNO : ""}
                      </td>
                      <td className="text-left">
                        {row?.TABLENO ? row?.TABLENO : ""}
                      </td>
                      <td className="text-left">
                        {row?.WAITER ? row?.WAITER : ""}
                      </td>
                      <td className="text-left">
                        {row.DATETIME
                          ? moment
                              .utc(row.DATETIME)
                              ?.format("DD-MM-YYYY HH:mm:ss")
                          : ""}
                      </td>
                      {/* <td className="text-left">
                                  {row["CLIENT NAME"] ? row["CLIENT NAME"] : ""}
                                </td> */}
                      <td className="text-right pr-12">
                        {row.AMOUNT
                          ? row.AMOUNT.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "0.0"}
                      </td>
                      <td className="text-right pr-12">
                        {row.RECEIPTAMOUNT
                          ? row.RECEIPTAMOUNT.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "0.0"}
                      </td>
                      <td className="text-right">{row.PENDING || "0"}</td>
                      <td className="text-left">{row.CURRENCY || ""}</td>
                                          <td className="text-left">
                        {row.CREATEDDATE
                          ? moment
                              .utc(row.CREATEDDATE)
                              ?.format("DD-MM-YYYY")
                          : ""}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="w-[625px] sticky bottom-0 z-30 bg-white border-t border-gray-300 flex flex-row items-center gap-2  py-1 shadow-md">
                <p className="mx-2">Total Orders :</p>
                <input
                  className="w-48 h-6 border-black border rounded text-right"
                  value={filtSales.length > 0 ? filtSales.length : "0"}
                  readOnly
                ></input>
                <p className="mx-2">Total Amount :</p>
                <input
                  className="w-48 h-6 border-black border rounded text-right"
                  value={
                    salTotal
                      ? salTotal.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : "0"
                  }
                ></input>
              </div>
            </aside>
          </div>
        </>
      )}

      {showCashPos && (
        <div className="fixed top-[70px] left-1/2 -translate-x-1/2 bg-white border border-black lg:h-[calc(100vh-90px)] h-[calc(100vh-80px)] lg:w-[1250px] w-[95%] p-1 overflow-y-auto z-[500] rounded-md shadow-xl">
          {/* <div className="relative top-0  left-1/2 transform -translate-x-1/2 -translate-y-1/2  bg-white border border-black lg:h-[500px] h-[80%] lg:w-[1250px] w-[95%] p-1 overflow-y-auto z-[500]"> */}
          <CashPOSPopUp ordernoToPass={orderNo} hideNavBar={true} />

          <button
            className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => setShowCashPos(false)}
          >
            Close
          </button>
        </div>
      )}

     
      {activeTab === "inventory" && (
        <>
          <div className="h-[30vh] w-full flex overflow-auto">
            <aside className="w-[500px] table__pos__app text-sm overflow-auto">
              <h3>POs Awaiting Approval</h3>
            </aside>
            <aside className="w-[500px] table__pos__app text-sm overflow-auto">
              <h3>Items going below ROL</h3>
            </aside>
            <aside className="w-[500px] table__pos__app text-sm overflow-auto">
              <h3>Kitchen Supply Requests not Approved</h3>
            </aside>
          </div>

          <div className="h-[30vh] w-full flex overflow-auto">
            <aside className="w-[500px] table__pos__app text-sm overflow-auto">
              <h3>Pending GRNs</h3>
            </aside>
            <aside className="w-[500px] table__pos__app text-sm overflow-auto">
              <h3>Items Due to Expiry</h3>
            </aside>
            <aside className="w-[500px] table__pos__app text-sm overflow-auto">
              <h3>Pending Kitchen Supply Requests</h3>
            </aside>
          </div>
        </>
      )}

      {activeTab === "financials" && (
        <>
        </>
      )}

          </>
      )}
    </div>
  );
};

export default HomePage;
